<template>
  <div class="et-tool">
    <!-- Hero -->
    <div class="et-hero">
      <div class="et-hero-icon"><i class="el-icon-truck" /></div>
      <div class="et-hero-text"><h3>{{ $t('tool.ExpressTracking.title') }}</h3></div>
    </div>

    <!-- Search -->
    <div class="et-search">
      <el-input v-model="trackingNo" :placeholder="$t('tool.ExpressTracking.phInput')" size="medium"
        class="et-inp" @keyup.enter.native="query" clearable />
      <el-button type="primary" size="medium" icon="el-icon-search" @click="query">{{ $t('tool.ExpressTracking.btnQuery') }}</el-button>
    </div>

    <!-- Error -->
    <div class="et-err" v-if="error">{{ error }}</div>

    <!-- Result -->
    <div class="et-cards" v-if="result">
      <div class="et-card">
        <span class="et-card-label">{{ $t('tool.ExpressTracking.courier') }}</span>
        <span class="et-card-val et-card-em">{{ result.company.icon }} {{ result.company.name }}</span>
      </div>
      <div class="et-card">
        <span class="et-card-label">{{ $t('tool.ExpressTracking.trackingNo') }}</span>
        <span class="et-card-val">
          <code>{{ trackingNo }}</code>
          <el-button size="mini" plain icon="el-icon-document-copy" @click="copyNo" style="margin-left:8px">{{ $t("common.action.copy") }}</el-button>
        </span>
      </div>
    </div>
    <div class="et-actions" v-if="result">
      <el-button type="primary" icon="el-icon-link" @click="openUrl">{{ $t('tool.ExpressTracking.goOfficial') }}</el-button>
      <el-button plain @click="reset">{{ $t('tool.ExpressTracking.requery') }}</el-button>
    </div>

    <!-- Courier list -->
    <div class="et-courier-section">
      <div class="et-courier-title">{{ $t('tool.ExpressTracking.courierList', { n: couriers.length }) }}</div>
      <div class="et-couriers">
        <div v-for="c in couriers" :key="c.key" class="et-courier-item" @click="fillExample(c)">
          <span class="et-courier-icon">{{ c.icon }}</span>
          <div class="et-courier-body">
            <span class="et-courier-name">{{ c.name }}</span>
            <code class="et-courier-example">{{ c.examples[0] }}</code>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var COURIERS = [
  { key:'sf', name:'顺丰速运', icon:'📦', url:function(no){return'https://www.sf-express.com/we/ow/chn/sc/waybill/waybill-detail/'+no},examples:['SF123456789012']},
  { key:'yto', name:'圆通速递', icon:'🔴', url:function(no){return'https://www.yto.net.cn/tools/waybill-search.html?waybillNo='+no},examples:['YT1234567890123']},
  { key:'zto', name:'中通快递', icon:'🔵', url:function(no){return'https://www.zto.com/express-detail?billCode='+no},examples:['75123456789012']},
  { key:'sto', name:'申通快递', icon:'🟡', url:function(no){return'https://www.sto.cn/bill-query?waybillNo='+no},examples:['77301234567890']},
  { key:'yd', name:'韵达快递', icon:'🟠', url:function(no){return'https://www.yundaex.com/query?waybillNo='+no},examples:['43123456789012']},
  { key:'jtexpress', name:'极兔速递', icon:'🐰', url:function(no){return'https://www.jtexpress.com/track?billCode='+no},examples:['JT1234567890123']},
  { key:'ems', name:'邮政EMS', icon:'📮', url:function(no){return'https://www.ems.com.cn/query?trackNum='+no},examples:['9876543210123']},
  { key:'jd', name:'京东物流', icon:'🐶', url:function(no){return'https://www.jdl.com/tracking?waybillNo='+no},examples:['JD0012345678901']},
  { key:'deppon', name:'德邦快递', icon:'📋', url:function(no){return'https://www.deppon.com/express/tracking?billCode='+no},examples:['DPK123456789012']},
  { key:'best', name:'百世快递', icon:'🅱', url:function(no){return'https://www.800best.com/track?waybillNo='+no},examples:['51234567890123']}
]

var RULES = [
  { test:function(no){return/^SF\d{12}$/.test(no)||/^SF\d{14,}$/.test(no)},company:'sf'},
  { test:function(no){return/^YT\d{13,}$/.test(no)},company:'yto'},
  { test:function(no){return/^(77\d{10,}|STO\d+)$/.test(no)},company:'sto'},
  { test:function(no){return/^(7\d{11,}|ZTO\d+)$/.test(no)},company:'zto'},
  { test:function(no){return/^(4\d{12,}|YD\d+)$/.test(no)},company:'yd'},
  { test:function(no){return/^JT\d{13,}$/.test(no)},company:'jtexpress'},
  { test:function(no){return/^(9\d{12}|10\d{12}|11\d{12}|12\d{12}|13\d{12}|EMS\d+|EA\d+)$/.test(no)},company:'ems'},
  { test:function(no){return/^JD\d{10,}$/.test(no)||/^JDV\d+$/.test(no)},company:'jd'},
  { test:function(no){return/^(DP|DPK)\d{10,}$/.test(no)},company:'deppon'},
  { test:function(no){return/^(5\d{12,}|BEST\d+)$/.test(no)},company:'best'}
]

var COURIER_MAP = {}
COURIERS.forEach(function(c){COURIER_MAP[c.key]=c})

export default {
  name:'ExpressTrackingTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({trackingNo:'',result:null,error:'',couriers:COURIERS}),
  methods:{
    query(){
      var no=this.trackingNo.trim()
      if(!no){this.error=this.$t('tool.ExpressTracking.emptyInput');return}
      this.result=null;this.error=''
      var company=null
      for(var i=0;i<RULES.length;i++){if(RULES[i].test(no)){company=COURIER_MAP[RULES[i].company];break}}
      if(company){this.result={company:{name:company.name,icon:company.icon},url:company.url(no)}}
      else{this.error=this.$t('tool.ExpressTracking.notRecognized')}
    },
    fillExample(c){if(c.examples&&c.examples[0]){this.trackingNo=c.examples[0];this.query()}},
    openUrl(){if(this.result&&this.result.url)window.open(this.result.url,'_blank')},
    copyNo(){navigator.clipboard.writeText(this.trackingNo);this.$message.success(this.$t("common.status.copied"))},
    reset(){this.trackingNo='';this.result=null;this.error=''},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.et-tool { display:flex;flex-direction:column;gap:20px; }

/* Hero */
.et-hero { display:flex;align-items:center;gap:16px; }
.et-hero-icon {
  width:52px;height:52px;border-radius:14px;flex-shrink:0;
  background:#f0f4ff;display:flex;align-items:center;justify-content:center;
  font-size:24px;color:#4e7cff;
}
.et-hero-text h3 { margin:0;font-size:16px;font-weight:700;color:#1a1f36; }

/* Search */
.et-search { display:flex;gap:10px; }
.et-inp { flex:1;min-width:0; }
.et-inp >>> input { font-family:'Courier New',monospace;font-size:15px !important;letter-spacing:.5px; }

/* Error */
.et-err { padding:12px 16px;background:#fef0f0;border:1px solid #fde2e2;border-radius:8px;color:#f56c6c;font-size:13px; }

/* Result cards */
.et-cards { display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:10px; }
.et-card {
  background:#f0f9eb;border:1px solid #e1f3d8;border-radius:10px;
  padding:16px 18px;display:flex;flex-direction:column;gap:6px;
}
.et-card-label { font-size:11px;font-weight:600;color:#909399;text-transform:uppercase;letter-spacing:1px; }
.et-card-val { font-size:15px;color:#303133;font-weight:500;display:flex;align-items:center;flex-wrap:wrap;gap:4px; }
.et-card-val code { font-family:'Courier New',monospace;font-size:14px;color:#1a1f36; }
.et-card-em { font-size:18px;font-weight:700;color:#1a1f36; }

.et-actions { display:flex;gap:8px; }

/* Courier list */
.et-courier-section { }
.et-courier-title { font-size:12px;color:#909399;margin-bottom:10px; }
.et-couriers { display:grid;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:8px; }
.et-courier-item {
  display:flex;align-items:center;gap:10px;padding:10px 14px;
  background:#fafbfc;border:1px solid #ebeef5;border-radius:8px;
  cursor:pointer;transition:all .15s;
}
.et-courier-item:hover { background:#f0f4ff;border-color:#4e7cff; }
.et-courier-icon { font-size:22px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;background:#f0f2f5;border-radius:8px;flex-shrink:0; }
.et-courier-body { display:flex;flex-direction:column;gap:2px;min-width:0; }
.et-courier-name { font-size:14px;font-weight:600;color:#303133; }
.et-courier-example { font-size:11px;color:#909399;font-family:monospace;overflow:hidden;text-overflow:ellipsis;white-space:nowrap; }

@media (max-width:640px) {
  .et-search { flex-direction:column; }
  .et-cards { grid-template-columns:1fr; }
  .et-couriers { grid-template-columns:1fr; }
}
</style>
